import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';
import Switch from '@mui/material/Switch';
import React from 'react';

// Base styled switch with dynamic color prop
const StyledBlackWhiteSwitch = styled(Switch)(({ theme, color }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: color === 'green' ? '#6ACE7F' : '#000', // Green thumb when checked
    "&:hover": {
      backgroundColor: alpha(color === 'green' ? '#6ACE7F' : '#000', theme.palette.action.hoverOpacity),
    },
    "&.Mui-disabled": {
      color: color === 'green' ? '#66b266' : '#ff6666', // Lighter green/red for disabled checked
    },
  },
  "& .MuiSwitch-switchBase": {
    color: color === 'red' ? '#f40000' : '#ccc', // Red thumb when unchecked
    "&:hover": {
      backgroundColor: alpha(color === 'red' ? '#f40000' : '#000', theme.palette.action.hoverOpacity),
    },
    "&.Mui-disabled": {
      color: color === 'red' ? '#ff6666' : '#cccccc', // Lighter red/gray for disabled unchecked
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: color === 'red' ? '#f40000' : '#ccc', // Red track when unchecked
    opacity: 1,
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: color === 'green' ? '#6ACE7F' : '#000', // Green track when checked
    opacity: 1,
  },
  "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: color === 'red' ? '#ff6666' : color === 'green' ? '#66b266' : '#cccccc', // Lighter red/green for disabled
    opacity: 0.7,
  },
}));

// Wrapper component to pass color based on checked value
const BlackWhiteSwitch = ({ checked, disabled }) => {
  const color = checked ? 'green' : 'red'; // Green for true, red for false
  return <StyledBlackWhiteSwitch checked={checked} disabled={disabled} color={color} />;
};

export default BlackWhiteSwitch;